module.exports = __webpack_public_path__ + "img/playbar_next_white.f0cce558.svg";